// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","button--secondary":"button_button--secondary__6qMtd","button--disabled":"button_button--disabled__Bqj8p"};